import { routeListAtom } from '@/interfaces/verify';
import { useAtom, useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';

import * as _ from 'lodash';
import { Collapse, List, ListItemButton, ListItemText, ListSubheader } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { backdropAtom } from '@/commons/constants';
import styled from 'styled-components';
import { selectedVerifyRouteAtom } from './constants';

const MainWrap = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  flex-grow:1;
`;

export default function RouteList() {
  const [{ data, isLoading }] = useAtom(routeListAtom);
  const [routeList, setRouteList] = useState<any[]>(undefined);
  const setBackdrop = useSetAtom(backdropAtom);

  useEffect(() => {
    if (data && data.length > 0) {
      setRouteList(data);
    }
  }, [data]);

  useEffect(() => {
    if (isLoading) {
      setBackdrop(true);
      setRouteList(undefined);
    } else {
      setBackdrop(false);
    }
  }, [isLoading]);
  return (
    <MainWrap>
      {routeList && routeList.length > 0 && (
        <List
          sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              배차목록 ({routeList.length}건)
            </ListSubheader>
          }
        >
          {routeList.map((item, index) => {
            return <ListItem key={index} item={item} />;
          })}
        </List>
      )}
    </MainWrap>
  );
}

const ListItem = ({ item }: { item: any }) => {
  const selectedVerifyRoute = useSetAtom(selectedVerifyRouteAtom);

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <>
      <ListItemButton onClick={handleClick}>
        <ListItemText primary={item.date + ' (' + item.val.length + ')'} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      {item.val.length > 0 && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          {item.val.map((vItem: any) => {
            return (
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => selectedVerifyRoute(vItem)}>
                  <ListItemText primary={vItem.car_id} />
                </ListItemButton>
              </List>
            );
          })}
        </Collapse>
      )}
    </>
  );
};
